import React, { useState, useEffect } from 'react';
// Script Path & Filename: frontend/src/components/DatabaseAdminV2.jsx
import { DynamicTableViewer } from './DynamicTableViewerV2';
import { UIConfigModal } from './UIConfigModal';
import { VirtualSchemaManager } from './VirtualSchemaManager';

export const DatabaseAdminV2 = ({ token }) => {
    const [tables, setTables] = useState([]);
    const [selectedTable, setSelectedTable] = useState('');
    const [uiConfig, setUiConfig] = useState([]);
    const [missingConfig, setMissingConfig] = useState(null);
    const [adminView, setAdminView] = useState('browser'); // 'browser' or 'virtual'

    const fetchCoreData = async () => {
        const headers = { 'Authorization': `Bearer ${token}` };
        try {
            const tblRes = await fetch('/api/data/schema/tables', { headers });
            if (tblRes.ok) {
                const tblData = await tblRes.json();
                const tableNames = Array.isArray(tblData) ? tblData.map(t => t.TableName) : [];
                setTables(tableNames);
                if (tableNames.length > 0 && !selectedTable) {
                    setSelectedTable(tableNames[0]);
                }
            }
            
            const cfgRes = await fetch('/api/data/uiconfig', { headers });
            if (cfgRes.ok) {
                setUiConfig(await cfgRes.json());
            }
        } catch (err) {
            console.error("Failed to load schema context", err);
        }
    };

    useEffect(() => {
        fetchCoreData();
    }, [token]);

    return (
        <div className="flex-1 flex flex-col min-h-0 min-w-0 bg-slate-900 h-full">
            {/* Header Tabs */}
            <div className="bg-slate-800 border-b border-slate-700 px-6 py-2 flex items-center justify-between shrink-0 shadow-md">
                <div className="flex items-center space-x-2">
                    <span className="material-symbols-outlined text-blue-500 mr-2">database</span>
                    <h1 className="text-md font-bold text-white tracking-wide uppercase">Database Administration</h1>
                </div>
                <div className="flex space-x-1 bg-slate-900/50 p-1 rounded border border-slate-700">
                    <button 
                        onClick={() => setAdminView('browser')}
                        className={`px-4 py-1.5 rounded text-xs uppercase tracking-wider font-semibold transition-colors flex items-center ${adminView === 'browser' ? 'bg-blue-600 text-white shadow' : 'text-slate-400 hover:text-white'}`}
                    >
                        <span className="material-symbols-outlined text-[16px] mr-1.5">table_rows</span>
                        Physical Tables
                    </button>
                    <button 
                        onClick={() => setAdminView('virtual')}
                        className={`px-4 py-1.5 rounded text-xs uppercase tracking-wider font-semibold transition-colors flex items-center ${adminView === 'virtual' ? 'bg-blue-600 text-white shadow' : 'text-slate-400 hover:text-white'}`}
                    >
                        <span className="material-symbols-outlined text-[16px] mr-1.5">settings_suggest</span>
                        Virtual Schema definitions
                    </button>
                </div>
            </div>

            {adminView === 'browser' ? (
                <div className="flex-1 overflow-hidden min-h-0 min-w-0 bg-slate-800 rounded-lg border border-slate-700 flex flex-col h-full m-4">
                    {selectedTable ? (
                        <DynamicTableViewer 
                            targetTable={selectedTable} 
                            token={token} 
                            uiConfig={uiConfig} 
                            onMissingConfig={setMissingConfig} 
                            apiPrefix="/api/v2/data"
                            onTableChange={setSelectedTable}
                        />
                    ) : (
                        <div className="flex-1 flex items-center justify-center text-slate-500">
                            Loading database schema...
                        </div>
                    )}
                </div>
            ) : (
                <div className="flex-1 overflow-hidden flex flex-col min-h-0">
                    <VirtualSchemaManager token={token} schemaGroup="Core" tableName={selectedTable} />
                </div>
            )}

            {missingConfig && (
                <UIConfigModal 
                    token={token}
                    schema={missingConfig.schema}
                    table={missingConfig.table}
                    onClose={() => setMissingConfig(null)}
                    onSuccess={() => { setMissingConfig(null); fetchCoreData(); }}
                />
            )}
        </div>
    );
};